import { createContext, useContext } from 'react';

/**
 * Runtime-resolved roadmap display flags. Each flag is a boolean (no auto
 * fallback at consume-time — resolution happens once at the root).
 */
export interface ResolvedDisplayOptions {
  showObjective: boolean;
  showEntryPath: boolean;
}

export const DEFAULT_DISPLAY_OPTIONS: ResolvedDisplayOptions = {
  showObjective: true,
  showEntryPath: true,
};

export const DisplayOptionsContext =
  createContext<ResolvedDisplayOptions>(DEFAULT_DISPLAY_OPTIONS);

export function useDisplayOptions(): ResolvedDisplayOptions {
  return useContext(DisplayOptionsContext);
}
